import { Lever } from "./useLever"

export const useSearchJob = (
  jobData: Lever,
  searchStr: string,
  locFilter: string[],
  teamsFilter: string[]
) => {
  const jobIDSet = new Set()
  const resJobIDArr: string[] = []
  if (!searchStr && !locFilter.length && !teamsFilter.length) return resJobIDArr
  if (locFilter.length) {
    locFilter.forEach(item => {
      jobData.jobMapByLocation[item].forEach(id => {
        jobIDSet.add(id)
      })
    })
  }

  if (teamsFilter.length) {
    teamsFilter.forEach(item => {
      jobData.jobMapByTeam[item].forEach(id => {
        if (jobIDSet.has(id)) {
          resJobIDArr.push(id)
        }
      })
    })
  }

  if (searchStr) {
    const lowerCaseSearchStr = searchStr.toLowerCase()
    const jobIDAfterSearch: string[] = []
    resJobIDArr.forEach(id => {
      if (
        jobData.jobs[id].text.toLowerCase().indexOf(lowerCaseSearchStr) >= 0
      ) {
        jobIDAfterSearch.push(id)
      }
    })
    return jobIDAfterSearch
  }

  return resJobIDArr
}
